import { FilterIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

const EmptyState = ({ className }: { className?: string }) => {
  return (
    <div
      className={twMerge(
        "flex flex-1 flex-col items-center justify-center px-3 my-3",
        className
      )}
    >
      <FilterIcon className="w-6 h-6 fill-light-gray" />
      <p className="text-txtPlaceholder text-[12px] text-center font-sans">
        Select a dataset first to add attribute filters.
      </p>
    </div>
  );
};

export default EmptyState;
